// AIDEV-NOTE: Primitives for preserving a text selection across a toolbar-button tap. On touch
// devices the tap collapses the page selection before the click handler runs, so selection-driven
// tools (translate, read-aloud) capture the range first and re-apply it before acting on the text.

export const currentSelectionRange = (): Range | null => {
  const selection = window.getSelection();

  if (selection && selection.rangeCount > 0 && selection.toString().length > 0) {
    return selection.getRangeAt(0).cloneRange();
  }

  return null;
};

export const restoreSelectionRange = (range: Range | null): void => {
  if (!range || range.toString().length === 0) return;

  const selection = window.getSelection();
  if (!selection) return;

  selection.removeAllRanges();
  selection.addRange(range);
};
